
import React, { ReactNode } from 'react';
import { CancerContext } from './contexts/CancerContext';
import { useDiagnosisOperations } from './hooks/useDiagnosisOperations';

export interface CancerProviderProps {
  children: ReactNode;
}

export const CancerProvider = ({ children }: CancerProviderProps) => {
  const diagnosisOperations = useDiagnosisOperations();
  
  return (
    <CancerContext.Provider value={diagnosisOperations}>
      {children}
    </CancerContext.Provider>
  );
};

// Re-export the useCancer hook for convenience
export { useCancer } from './contexts/CancerContext';
